import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Portal,
  Select,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import { useFormik } from "formik";

import { useEffect, useRef, useState } from "react";

import { MdDeleteOutline, MdOutlineAdd } from "react-icons/md";
import { IPostAvailableCourse } from "../../models/admin/availableCourse.model";
import {
  ICourseSession,
  ICourseTerm,
} from "../../models/admin/courseTermSession.model";
import { ICenter } from "../../models/centers.model";
import AdminHelpers from "../../services/admin/admin.service";
import coursesService from "../../services/courses.service";
import { formatDate } from "../../utils/dates";
import { CenterModal } from "./center-modal";

export const AvailableCourseModal: React.FC<any> = ({
  courseId,
  isOpens,
  onCloses,
  updateRecord,
  isUpdate,
  id,
}: {
  courseId: string;
  isOpens: any;
  onCloses: any;
  updateRecord: any;
  isUpdate: boolean;
  id: string | number;
}) => {
  const [session, setSession] = useState<ICourseSession[]>([]);
  const [term, setTerms] = useState<ICourseTerm[]>([]);
  const [centersId, setCentersId] = useState<string[]>([]);
  const [centers, setCenters] = useState<any>([]);
  const [courseAvailabilityId, setCourseAvailabilityId] = useState<
    string | number
  >();
  const [courseAvailabilityUUId, setCourseAvailabilityUUId] = useState<
    string | number
  >();
  const [allAvailableCentersId, setAllAvailableCentersId] = useState<string[]>(
    []
  );
  const [allAvailablecenters, setAllAvailableCenters] = useState<any>([]);
  const [advertisement_start_date, onChangeadvertisement_start_date] =
    useState<string>();
  const [admission_start, onChangeadmission_start] = useState<string>();
  const [admission_end, onChangeadmission_end] = useState<string>();
  const [training_start, onChangetraining_start] = useState<string>();
  const [training_end, onChangetraining_end] = useState<string>();
  const [isCenter, setIsCenter] = useState(false);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0");
    const day = today.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    AdminHelpers.getSessions()
      .then((response) => {
        setSession(response.data);
      })
      .catch((err) => err);
    AdminHelpers.getTerms()
      .then((response) => {
        setTerms(response.data);
      })
      .catch((err) => err);
    coursesService.getCourse(courseId).then((res) => {
      setAllAvailableCenters(res.data?.centres);
      setCenters(res.data?.centres);
      const centers_response = res.data?.centres;
      if (centers_response.length > 0) {
        setCentersId(
          centers_response.map((center: any) => center.id.toString())
        );
        if (!isUpdate)
          setAllAvailableCentersId(
            centers_response.map((center: any) => center.id.toString())
          );
      }
    });

    if (isUpdate && id) {
      coursesService.getanAvailableCourse(id).then((res) => {
        const available_course = res;
        formik.setValues({
          session: available_course.session_id.toString(),
          term: available_course.term_id.toString(),
        });
        // set course availability id there
        setCourseAvailabilityId(available_course?.id);
        setCourseAvailabilityUUId(available_course?.uuid);
        onChangeadvertisement_start_date(() =>
          formatDate(available_course.advertisement_start_date || new Date())
        );
        onChangeadmission_start(() =>
          formatDate(available_course.admission_start)
        );
        onChangeadmission_end(() => formatDate(available_course.admission_end));
        onChangetraining_start(() =>
          formatDate(available_course.training_start)
        );
        onChangetraining_end(() => formatDate(available_course.training_end));
        setCentersId(available_course?.centre_ids?.split(","));
        setAllAvailableCentersId(
          available_course?.centre_ids?.split(",")
        );

        setAllAvailableCenters(available_course?.centres);
        setCenters(available_course?.centres);

      });
    } else {
      formik.setValues({
        session: "",
        term: "",
      });
      onChangeadvertisement_start_date("");
      onChangeadmission_start("");
      onChangeadmission_end("");
      onChangetraining_start("");
      onChangetraining_end("");
      setCenters([]);
    }
  }, [courseId]);

  const updateCenters = (centres: ICenter[], centersId: any[]) => {
    setCenters((prevCenters: ICenter[]) => {
      const newCenters = centres.filter(
        (center) =>
          !prevCenters?.some((prevCenter) => prevCenter.id === center.id)
      );
      return [...prevCenters, ...newCenters];
    });

    setCentersId((prevCentersId: string[]) => {
      const newCentersId = centersId.filter(
        (id) => !prevCentersId?.includes(id)
      );
      return [...prevCentersId, ...newCentersId];
    });
  };

  const openCenterModal = () => {
    // setIsCenter(true);
    onOpen();
  };

  const cancelRef = useRef().current;
  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};

      if (!values.session) {
        errors.session = "Session is required";
      }
      if (!values.term) {
        errors.term = "Term is required";
      }
      return errors;
    },
    initialValues: {
      session: "",
      term: "",
    },

    onSubmit: async (values) => {
      const availableCourse: IPostAvailableCourse = {
        course_id: courseId,
        session_id: values.session,
        term_id: values.term,
        advertisement_start_date: advertisement_start_date,
        admission_start: admission_start,
        admission_end: admission_end,
        training_start: training_start,
        training_end: training_end,
        centre_ids: centersId,
      };

      try {
        if (isUpdate) {
          const data: any = {
            ...availableCourse,
            advertisement_start_date: new Date(
              advertisement_start_date as string
            ).toISOString(),
            admission_start: new Date(admission_start as string).toISOString(),
            admission_end: new Date(admission_end as string).toISOString(),
            training_start: new Date(training_start as string).toISOString(),
            training_end: new Date(training_end as string).toISOString(),
            course_availability_id: courseAvailabilityId?.toString(),
          };
          const basicResponse = await AdminHelpers.updateAvailableCourse(
            data,
            courseAvailabilityUUId as string
          );
          if (basicResponse) {
            onCloses();
            updateRecord();
            toast({
              title: "Course Availability",
              description: "Course availability updated",
              status: "success",
            });
          }
        } else {
          const basicResponse = await AdminHelpers.availableCourse(
            availableCourse
          );
          if (basicResponse) {
            onCloses();
            updateRecord();
            toast({
              title: "Course Availability",
              description: "Course made available",
              status: "success",
            });
          }
        }
      } catch (error: any) {
        toast({
          title: "Course Availability",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  const handleCloseModal = () => {
    onCloses();
    formik.resetForm();
    onChangeadvertisement_start_date("");
    onChangeadmission_start("");
    onChangeadmission_end("");
    onChangetraining_start("");
    onChangetraining_end("");
    setCenters([]);
  };

  const removeCenter = (center: number) => {
    const updatedCentersId = [...centersId];
    const updatedCenters = [...centers];

    const ind = updatedCentersId.indexOf(center.toString());
    if (ind !== -1) {
      updatedCentersId.splice(ind, 1);
      updatedCenters.splice(ind, 1);
    }

    setCentersId(updatedCentersId);
    setCenters(updatedCenters);
  };

  return (
    <>
      <Modal
        isOpen={isOpens}
        onClose={handleCloseModal}
        scrollBehavior="inside"
        closeOnOverlayClick={true}
        size="md"
        isCentered
      >
        <ModalOverlay />
        <ModalContent borderRadius={5} px={3} pb="10px">
          <ModalHeader>
            <Flex justifyContent="center">
              <Box>
                <Flex justifyContent="center">
                  <Text
                    mx="auto"
                    color="#353535"
                    fontSize="22px"
                    fontWeight="800"
                  >
                    {isUpdate
                      ? "Edit Course Availability"
                      : "Course Availability"}
                  </Text>
                </Flex>
              </Box>
            </Flex>
          </ModalHeader>
          <ModalCloseButton size="sm" />

          <ModalBody>
            <Box mt={4}>
              <form onSubmit={formik.handleSubmit}>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.session && formik.touched.session
                      ? true
                      : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Session *
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select session"
                    value={formik.values.session}
                    name="session"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {session.map((each, index) => (
                      <option key={index} value={each.id}>
                        {" "}
                        {each.title}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.session}
                  </FormErrorMessage>
                </FormControl>
                <FormControl
                  mb="26px"
                  isInvalid={
                    formik.errors.term && formik.touched.term ? true : false
                  }
                >
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Term
                  </FormLabel>
                  <Select
                    variant="outline"
                    bg="inputText.500"
                    size="sm"
                    placeholder="Select term"
                    value={formik.values.term}
                    name="term"
                    onChange={formik.handleChange}
                    fontSize="14px"
                    color="brand.subtitle"
                  >
                    {term.map((each, index) => (
                      <option key={index} value={each.id}>
                        {" "}
                        {each.title}{" "}
                      </option>
                    ))}
                  </Select>
                  <FormErrorMessage fontSize={12}>
                    {formik.errors.term}
                  </FormErrorMessage>
                </FormControl>
                <FormControl pb="25px">
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    <Flex>
                      <Text mr="10px">Add Centers</Text>
                      <Center
                        fontSize="20px"
                        onClick={() => {
                          openCenterModal();
                        }}
                        border="lightgray 2px dashed"
                      >
                        <MdOutlineAdd />
                      </Center>
                    </Flex>
                  </FormLabel>
                  {centers.length > 0 &&
                    centers.map((each: any, index: number) => (
                      <Flex
                        pb="8px"
                        key={index}
                        width="240px"
                        justifyContent="space-between"
                      >
                        <Text>{each.name}</Text>
                        <Center
                          cursor={"pointer"}
                          fontSize="20px"
                          onClick={() => {
                            removeCenter(each.id);
                          }}
                        >
                          <MdDeleteOutline />
                        </Center>
                      </Flex>
                    ))}
                </FormControl>

                <FormControl mb="15px">
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Advertisement Start Date
                  </FormLabel>
                  <div>
                    <Input
                      type="date"
                      onChange={(e) =>
                        onChangeadvertisement_start_date(e.target.value)
                      }
                      value={advertisement_start_date}
                      // min={getCurrentDate()}
                    />
                  </div>
                </FormControl>
                <FormControl mb="15px">
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Admission Start date
                  </FormLabel>
                  <div>
                    <Input
                      type="date"
                      onChange={(e) => onChangeadmission_start(e.target.value)}
                      value={admission_start}
                      // min={getCurrentDate()}
                    />
                  </div>
                </FormControl>
                <FormControl mb="15px" width={"100%"}>
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Admission End Date
                  </FormLabel>
                  <div>
                    <Input
                      type="date"
                      onChange={(e) => onChangeadmission_end(e.target.value)}
                      value={admission_end}
                      // min={getCurrentDate()}
                    />
                  </div>
                </FormControl>
                <FormControl mb="15px">
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Training Start Date
                  </FormLabel>
                  <div>
                    <Input
                      type="date"
                      onChange={(e) => onChangetraining_start(e.target.value)}
                      value={training_start}
                      // min={getCurrentDate()}
                    />
                  </div>
                </FormControl>
                <FormControl mb="15px">
                  <FormLabel fontWeight="700" color="#616161" fontSize="14px">
                    Training End Date
                  </FormLabel>
                  <div>
                    <Input
                      type="date"
                      onChange={(e) => onChangetraining_end(e.target.value)}
                      value={training_end}
                      // min={getCurrentDate()}
                    />
                  </div>
                </FormControl>

                <Flex mt={12} justifyContent="end">
                  <HStack>
                    <Button
                      colorScheme="red"
                      type="submit"
                      size="sm"
                      px={6}
                      fontSize={12}
                    >
                      {isUpdate ? "UPDATE" : "CONFIRM"}
                    </Button>
                  </HStack>
                </Flex>
              </form>
            </Box>
            {isOpen && (
              <Portal>
                {" "}
                <CenterModal
                  isOpenCenter={isOpen}
                  onCloseCenter={onClose}
                  isCenter={isCenter}
                  updateCenters={updateCenters}
                  centers={allAvailablecenters}
                  centersId={allAvailableCentersId}
                />{" "}
              </Portal>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
